import React from "react";
import { Upload } from "../../assets/svg";

const FileUpload = ({ onChange, file }) => {
  const id = "file-input" + Math.random();
  return (
    <div className="try__btn-wrap">
      <input type={"file"} accept="application/pdf" id={id} className="hide" value={file} onChange={onChange} />

      <label htmlFor={id} className="try__button">
        <Upload />
        Upload PDF
      </label>
    </div>
  );
};

export default FileUpload;
